var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1",
    d: "M35.4156 18.5524C35.4156 27.6385 27.8295 35.0691 18.3905 35.0691C8.95149 35.0691 1.36544 27.6385 1.36544 18.5524C1.36544 9.46638 8.95149 2.03579 18.3905 2.03579C27.8295 2.03579 35.4156 9.46638 35.4156 18.5524Z",
    fill: "#C0C0C0",
    stroke: "#4E5866",
    strokeWidth: 2.73089
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M18.3901 9.44919L20.1917 14.8408L20.5034 15.7735H21.4868H27.2086L22.6128 19.0202L21.784 19.6057L22.1056 20.5682L23.8815 25.8828L19.1779 22.56L18.3901 22.0034L17.6022 22.56L12.8986 25.8828L14.6745 20.5682L14.9962 19.6057L14.1674 19.0202L9.57151 15.7735H15.2934H16.2767L16.5884 14.8408L18.3901 9.44919Z",
    fill: "white",
    stroke: "#4E5866",
    strokeWidth: 2.73089
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.4012118344ee7fdf2e4040c89eccc679.svg";
export { ForwardRef as ReactComponent };